import {
    SAVE_CHANGES_STATE_KEY,
    COPY_AGREEMENT_STATE_KEY,
    DELETE_AGREEMENT_STATE_KEY,
    ADD_NEW_AGREEMENT_STATE_KEY,
    DELETE_AGREEMENT_PROMPT_STATE_KEY,
    COPY_METHOD_TOOLBAR,
    UNDO_METHOD_TOOLBAR,
    UNDO_CHANGES_ACCOUNT_KEY,
    ADD_METHOD_TOOLBAR,
    DELETE_METHOD_TOOLBAR,
    SAVE_METHOD_TOOLBAR,
    AGREEMENT_MAINTENANCE_TOOLBAR,
    HISTORY_METHOD_TOOLBAR,
    VERSION_HISTORY_STATE_KEY,
    ALL_ROLES,
    DELETE_AGREEMENTS_ROLE,
    UPDATE_AGREEMENTS_ROLE,
    ADD_TO_PACKAGE_AGREEMENT_STATE_KEY,
    ADD_TO_PACKAGES_TOOLBAR,
    AGREEMENT_MODAL_HEADER,
    UPDATE_PACKAGE_AGREEMENTS_ROLE
} from "../../../Consts";
import { COPY_ICON, UNDO_ICON, NEW_ICON, DELETE_ICON, VERSION_HISTORY_ICON, CREATE_NEW_ICON } from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { copyExistingAgreement, clearModalSearchResults, nextWorkflowInSession } from "../../../../redux/reducers/RepertoireReducer";
import { showYesNoPrompt, hideModal } from "../../../../redux/reducers/ModalReducer";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { DataSource } from "../../../types/DataSource";
import { IAgreementState } from "../../../../redux/types/IAgreementState";
import { IYesNoPromptViewModalProps } from "../../../components/modalViews/yesNoPromptView/YesNoPromptView";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import ToolbarComponent from "../../../components/toolBar/ToolBarComponent";
import { SaveOption } from "../../../types/SaveOption";
import { IWorkflowSearchResult } from "../../../types/IWorkflowSearchResult";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IWorkflowParams } from "../../../types/IWorkFlowParams";
import { EntityType } from "../../../types/EntityType";
import React from "react";

export interface IAgreementMaintenanceToolbarProps {
    changesMade: boolean;
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    clearModalSearchResults?: typeof clearModalSearchResults;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IRepertoireComponentDataItem;
    saveResultData: IRepertoireComponentDataItem;
    activeTab: number;
    lookupValues: ILookupDictionary;
    tabs: ITabReduxItem[];
    agreement: IAgreementState;
    deleteAgreement: () => void;
    saveChanges: (postAgreement: boolean) => void;
    addNewAgreement: (lookups: ILookupDictionary, isNew?: boolean, dataAction?: IDataActionToolbar[]) => void;
    copyExistingAgreement: typeof copyExistingAgreement;
    undoAgreement: () => void;
    resetMessageBanner: () => void;
    isNew?: boolean;
    dataSource?: DataSource;
    workflowFieldsData: IRepertoireComponentDataItem;
    currentUser?: string;
    searchVersionHistory: (agreementID: number, activeTabItem: ITabReduxItem, actionList: IDataActionToolbar[], dataSource: DataSource, paneIndex?: number) => void;
    isReadonly: boolean;
    roles?: string[];
    isWorkflowSessionStarted?: boolean;
    cancelWorkflowSession?: (activeTab: number) => void;
    nextWorkflowItem?: typeof nextWorkflowInSession;
    skipWorkflowItem?: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]
        , lookups: ILookupDictionary
        , otherIndicatorsWorkFlagTypes: string[]
        , dataActions: IDataActionToolbar[]
        , workMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
        , formats: FormatFields[]
        , readonlyIndicatorsWorkFlagTypes: string[]) => void;
    workflowSessionItems?: IWorkflowSearchResult[];
    currentWorkflowIndex?: number;
    refreshWorkDetails?: () => void;
    saveWorkflow?: (workflowparams: IWorkflowParams) => void;
    completeWorkflowOnSave: (value: boolean) => void;
    isOpenForWorkflowSession?: boolean;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => void;
}

export interface IAgreementMaintenanceToolbarState {
    loaded: boolean;
}

export type AgreementMaintenanceToolbarKeys = keyof IAgreementMaintenanceToolbarProps;

const AgreementMaintenanceToolbar: React.FC<IAgreementMaintenanceToolbarProps> = ({
      showYesNoPrompt,
            hideModal,
            resetMessageBanner,
            scroll,
            toolbarWidth,
            saveResultData,
            agreement,
            activeTab,
            lookupValues,
            tabs,
            dataSource,
            toolbarData,
            workflowFieldsData,
            isReadonly,
            isWorkflowSessionStarted,
            nextWorkflowItem,
            cancelWorkflowSession,
            skipWorkflowItem,
            workflowSessionItems,
            currentWorkflowIndex,
            isOpenForWorkflowSession,
            saveWorkflow,
            completeWorkflowOnSave,
            roles,
            changesMade,
            undoAgreement,
            deleteAgreement,
            addNewAgreement,
            toolbarData: { fields },
            copyExistingAgreement,
            currentUser,
            saveChanges,
            clearModalSearchResults,
            searchVersionHistory,
            addToPackages,
}) => {

    const copyWork = () => {
        const actionList = tabs[activeTab].dataActionToolbar;
        copyExistingAgreement(actionList, currentUser);
    }

    const deleteWorkAction = () => {
        const message: string = toolbarData.fields.find(f => f.name === DELETE_AGREEMENT_PROMPT_STATE_KEY).data;
        const propsModal: IYesNoPromptViewModalProps = {
            yesCallback: () => { deleteAgreement(); },
            noCallback: () => { hideModal(); }
        }
        showYesNoPrompt(AGREEMENT_MODAL_HEADER, propsModal, undefined, message);
    }

    const saveChangesAction = (saveOption: SaveOption) => {
        const postAgreement: boolean = saveOption === SaveOption.SavePost;
        saveChanges(postAgreement);
    }

    const setActionList = () => {
        const actionList = { ...tabs[activeTab] };
        const newActionList: IDataActionToolbar[] = [];

        actionList.dataActionToolbar.map(action => {
            const actionItem = setActionAndName(action);
            if (actionItem !== null)
                newActionList.push(actionItem);
        });

        return newActionList;
    }

    const searchVersionHistoryLocal = () => {
        const actionList = tabs[activeTab].dataActionToolbar;
        clearModalSearchResults();
        searchVersionHistory(agreement.agreementID, tabs[activeTab], actionList, dataSource);
    };
   
    const AddtoPackage= () => {
        addToPackages(currentUser,EntityType.Agreements ,[agreement.agreementID]);
    }
    
    const getDeleteAgreementRoleDisabled = (): boolean => {
        if (roles && (roles.includes(DELETE_AGREEMENTS_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

    const getUpdateAgreementRoleDisabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_AGREEMENTS_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

    const getAddToPackagesRoleDisabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_PACKAGE_AGREEMENTS_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

    const setActionAndName = (action: IDataActionToolbar) => {

        switch (action.method) {

            case COPY_METHOD_TOOLBAR: {
                return {
                    action: copyWork,
                    name: fields.find(copy => copy.name === COPY_AGREEMENT_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: COPY_ICON,
                    isReadOnly: getUpdateAgreementRoleDisabled()
                }
            }

            case UNDO_METHOD_TOOLBAR: {
                return {
                    action: undoAgreement,
                    name: fields.find(undo => undo.name === UNDO_CHANGES_ACCOUNT_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: UNDO_ICON,
                    isReadOnly: getUpdateAgreementRoleDisabled()
                }

            }

            case ADD_METHOD_TOOLBAR: {
                return {
                    action: addNewAgreement,
                    name: fields.find(add => add.name === ADD_NEW_AGREEMENT_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: NEW_ICON,
                    isReadOnly: getUpdateAgreementRoleDisabled()
                }
            }

            case DELETE_METHOD_TOOLBAR: {
                return {
                    action: () => deleteWorkAction(),
                    name: fields.find(match => match.name === DELETE_AGREEMENT_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: DELETE_ICON,
                    isReadOnly: getDeleteAgreementRoleDisabled() || getUpdateAgreementRoleDisabled()
                }
            }

            case SAVE_METHOD_TOOLBAR: {
                return {
                    action: saveChangesAction,
                    name: fields.find(save => save.name === SAVE_CHANGES_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: '',
                    isReadOnly: getUpdateAgreementRoleDisabled()
                }
            }

            case HISTORY_METHOD_TOOLBAR: {
                return {
                    action: searchVersionHistoryLocal,
                    name: fields.find(save => save.name === VERSION_HISTORY_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: VERSION_HISTORY_ICON
                }
            }
            
            case ADD_TO_PACKAGES_TOOLBAR: {
                return {
                    action: AddtoPackage,
                    name: fields.find(addtopackage => addtopackage.name === ADD_TO_PACKAGE_AGREEMENT_STATE_KEY).data,
                    component: action.component,
                    method: action.method,
                    icon: CREATE_NEW_ICON,
                    isReadOnly: getAddToPackagesRoleDisabled()
                }
            }
            

            default: return null;
        }
    }


        let localChangesMade = !getUpdateAgreementRoleDisabled() && changesMade

        const actionList = setActionList()

        return (
            <>
                <div className={isReadonly ? 'versionHistoryPointer' : ''}>
                    <ToolbarComponent
                        scroll={scroll}
                        toolbarWidth={toolbarWidth}
                        saveResultData={saveResultData}
                        resetMessageBanner={resetMessageBanner}
                        changesMade={localChangesMade}
                        agreement={agreement}
                        activeTab={activeTab}
                        lookupValues={lookupValues}
                        tabs={tabs}
                        showYesNoPrompt={showYesNoPrompt}
                        hideModal={hideModal}
                        dataSource={dataSource}
                        clearModalSearchResults={clearModalSearchResults}
                        isReadonly={isReadonly}
                        dataActionToolbar={actionList}
                        toolbarData={toolbarData}
                        component={AGREEMENT_MAINTENANCE_TOOLBAR}
                        isNew={tabs[activeTab].agreementMaintenanceState.isNew}
                        workflowFieldsData={workflowFieldsData}
                        isWorkflowSessionStarted={isWorkflowSessionStarted}
                        nextWorkflowItem={nextWorkflowItem}
                        skipWorkflowItem={skipWorkflowItem}
                        cancelWorkflowSession={cancelWorkflowSession}
                        workflowSessionItems={workflowSessionItems}
                        currentWorkflowIndex={currentWorkflowIndex}
                        isOpenForWorkflowSession={isOpenForWorkflowSession}
                        saveWorkflow={saveWorkflow}
                        roles={roles}
                        completeWorkflowOnSave={completeWorkflowOnSave}
                    />
                </div>
            </>
        );
    }

export default AgreementMaintenanceToolbar;
